<template>
  <!-- We have to specify duration since our blink animation repeats the fade-in 3 times, otherwise Vue will remove the transition classes after the 1st iteration -->
  <transition name="message" :duration="{ enter: 750, leave: 250 }">
    <span class="rf-message error">
      <slot></slot>
    </span>
  </transition>
</template>

<script>
export default {
  name: 'RfMessage'
}
</script>



// WEBPACK FOOTER //
// RfMessage.vue?dc1a179e